import { useLayoutEffect, useState, ReactNode } from "react"
import cn from "classnames"

import { Icon } from "components/Icon"
import { bodyStyles } from "utils/updateStyles"

interface MenuProps {
    children: ReactNode
    title?: string
    highlight?: boolean
    className?: string
    showDesktop?: boolean | null
}

export function Menu({ children, title, highlight, className, showDesktop }: MenuProps) {
    const [hidden, setHidden] = useState(true)
    useLayoutEffect(() => {
        if (!hidden) {
            bodyStyles.set(`max-height: 100vh; overflow: hidden;`)
        } else {
            bodyStyles.clean()
        }
        return bodyStyles.clean
    }, [hidden])
    return (
        <>
            <nav
                className={cn(
                    "mobile-navigation",
                    {
                        "mobile-navigation-is-show-desktop": showDesktop,
                    },
                    className
                )}
            >
                <div
                    className={cn("mobile-navigation__menu", {
                        "mobile-navigation__menu-hidden": hidden,
                        "mobile-navigation__menu-is-show-desktop": showDesktop,
                    })}
                >
                    <div className="mobile-navigation__header">
                        <div
                            className={cn("mobile-navigation__title", {
                                "mobile-navigation__highlight": highlight,
                            })}
                        >
                            {title}
                        </div>
                        <div className="mobile-navigation__close">
                            <Icon
                                type="close-white-small"
                                size="14"
                                onClick={() => setHidden(true)}
                            />
                        </div>
                    </div>
                    {children}
                </div>
                <div className="mobile-navigation__opener" onClick={() => setHidden(false)}>
                    <Icon type="menu-duo" size="18" />
                </div>
            </nav>
            {!hidden && showDesktop && (
                <div className="mobile-navigation__overlay" onClick={() => setHidden(true)} />
            )}
        </>
    )
}
